import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainDashboard from './pages/Dashboard/MainDashboard';
import RouteList from './pages/RouteManagement/RouteList';
import RouteUpload from './pages/RouteManagement/RouteUpload';
import RouteViewer from './pages/RouteManagement/RouteViewer';
import BroadcastMap from './pages/LiveMapCG/BroadcastMap';
import LiveCGMap from './pages/LiveCG/LiveCGMap';
import RemoteControl from './pages/RemoteControl/RemoteControl';

// Dark theme optimized for TV production control rooms
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#0a0a0a',
      paper: '#1a1a1a',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b0b0b0',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<MainDashboard />} />
          <Route path="/dashboard" element={<MainDashboard />} />
          <Route path="/routes" element={<RouteList />} />
          <Route path="/routes/upload" element={<RouteUpload />} />
          <Route path="/routes/view/:raceId" element={<RouteViewer />} />
          <Route path="/broadcast" element={<BroadcastMap />} />
          <Route path="/live-cg" element={<LiveCGMap />} />
          <Route path="/remote-control" element={<RemoteControl />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;